import { ResetPasswordDialog } from "./ResetPasswordDialog";

export interface ResetPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (password: string) => void;
  isSaving?: boolean;
  errorMessage?: string;
}

/**
 * The reset-password dialog's open/closed gate (FR-017, FR-017b, FR-051).
 *
 * Both pages open it live (`specs/my-info-write`).
 *
 * **Why this is a separate component from the dialog it renders.** All of the state — and therefore
 * the password value — lives in `ResetPasswordDialog`, which this component mounts only while open.
 * Closing therefore *unmounts* the value rather than hiding it, which is what FR-017b and FR-051
 * actually require. The obvious one-component shape (`if (!isOpen) return null`) does **not** do this:
 * `return null` clears a component's DOM output but keeps its fiber and its `useState` alive, so the
 * old password is still there on reopen. It looked correct and passed every DOM-level assertion; only
 * "presents empty fields when reopened" caught it. Do not collapse these two files back into one.
 */
export const ResetPasswordModal = ({
  isOpen,
  onClose,
  onConfirm,
  isSaving,
  errorMessage
}: ResetPasswordModalProps) =>
  isOpen ? (
    <ResetPasswordDialog
      errorMessage={errorMessage}
      isSaving={isSaving}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  ) : null;
